export default __webpack_public_path__ + "static/media/LockGolden.f660400d.svg";